module.exports = __webpack_public_path__ + "img/pack-duo.046ca01b.png";